import type { Tool } from '../../tool';
import { askUserQuestion as createAskUserQuestionTool } from '../../tools/ask-user-question';
import { ASK_USER_QUESTION_TOOL_NAME } from '../../tools/ask-user-question/constants';
import { Capability } from './base';

const ASK_USER_QUESTION_INSTRUCTIONS = `当你确实需要用户补充信息、做选择，或不明白用户为什么拒绝一次工具调用时，使用 ${ASK_USER_QUESTION_TOOL_NAME} 向用户提问。先根据现有上下文推进；只有在缺少用户回答会影响下一步执行时才提问`;

export class AskUserQuestionCapability extends Capability {
  readonly type = 'askUserQuestion';

  override tools(): Tool<any>[] {
    return [createAskUserQuestionTool()];
  }

  override instructions(): string {
    return ASK_USER_QUESTION_INSTRUCTIONS;
  }
}

export type AskUserQuestion = AskUserQuestionCapability;

export function askUserQuestion(): AskUserQuestion {
  return new AskUserQuestionCapability();
}
